import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Layout } from "../components/Layout";
import { Building2, QrCode, TrendingUp, Percent } from "lucide-react";
import * as apiClient from "../api";

const items = [
  { icon: Building2, title: "Hotel, B&B, Camping", desc: "Offri esperienze ai tuoi ospiti e guadagna una commissione su ogni prenotazione." },
  { icon: QrCode, title: "Codice QR & URL dedicati", desc: "Ricevi un link e un QR personalizzato da mostrare in reception o in camera." },
  { icon: TrendingUp, title: "Analytics in tempo reale", desc: "Monitora click, prenotazioni e valore generato dal tuo tracking univoco." },
  { icon: Percent, title: "Commissioni trasparenti", desc: "Percentuale concordata su ogni vendita, senza costi fissi." },
];

export default function Partner() {
  const { data: settings } = useQuery({ queryKey: ["publicSettings"], queryFn: apiClient.getPublicSettings });
  const wa = settings?.whatsapp ? String(settings.whatsapp).replace(/[^\d]/g, "") : "";
  const ctaHref = wa
    ? `https://wa.me/${wa}?text=Voglio%20diventare%20partner%20Cristalda`
    : settings?.email
      ? `mailto:${settings.email}?subject=Candidatura%20Partner%20Cristalda`
      : "/accedi";
  const ctaExternal = !!wa;
  return (
    <Layout>
      <div className="bg-gradient-to-br from-primary to-[#003A69] text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-16">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-secondary mb-2">Programma Partner</div>
          <h1 className="text-3xl sm:text-5xl font-heading font-semibold tracking-tight max-w-2xl">Diventa Partner di Cristalda Experience</h1>
          <p className="text-white/70 mt-4 max-w-xl">Hotel, B&B, ristoranti e beach club: trasforma i tuoi ospiti in esperienze indimenticabili e guadagna con ogni prenotazione.</p>
          {ctaExternal ? (
            <a href={ctaHref} target="_blank" rel="noopener noreferrer" data-testid="partner-cta" className="mt-8 inline-flex items-center gap-2 rounded-full bg-white text-primary font-semibold px-8 py-3.5 hover:bg-white/90 transition-colors">
              Candidati ora
            </a>
          ) : ctaHref.startsWith("mailto:") ? (
            <a href={ctaHref} data-testid="partner-cta" className="mt-8 inline-flex items-center gap-2 rounded-full bg-white text-primary font-semibold px-8 py-3.5 hover:bg-white/90 transition-colors">
              Candidati ora
            </a>
          ) : (
            <Link to={ctaHref} data-testid="partner-cta" className="mt-8 inline-flex items-center gap-2 rounded-full bg-white text-primary font-semibold px-8 py-3.5 hover:bg-white/90 transition-colors">
              Candidati ora
            </Link>
          )}
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid sm:grid-cols-2 gap-6">
          {items.map((it) => (
            <div key={it.title} className="rounded-2xl border border-slate-100 p-6 bg-white shadow-sm hover-lift">
              <div className="h-11 w-11 rounded-xl bg-primary/8 text-primary flex items-center justify-center mb-4"><it.icon className="h-5 w-5" /></div>
              <h3 className="font-heading font-semibold text-lg text-slate-900">{it.title}</h3>
              <p className="text-slate-500 mt-1 text-sm">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
